/**
 * Locale preset for appointment slot date pickers.
 *
 * Week layout is driven by dayjs (`lang.locale` → `en-gb`, `weekStart: 1`), not the app
 * i18n language or browser locale. The dayjs locale must be imported so it is registered.
 */

import 'dayjs/locale/en-gb';
import type { PickerLocale } from 'antd/es/date-picker/generatePicker';
import enGBDatePickerLocale from 'antd/es/date-picker/locale/en_GB';

/** Monday-first Ant Design date picker locale shared by appointment slot pickers. */
export const appointmentSlotDatePickerLocale: PickerLocale = enGBDatePickerLocale;
